import type { AnalyticsEvent } from "./types";

export const EVENTS = {
  ShowContinueInBrowserButton: {
    name: "continue_in_browser_shown",
    properties: {
      platform: "string",
    },
  },
  PressContinueInBrowserButton: {
    name: "continue_in_browser_button_press",
    properties: {
      platform: "string",
    },
  },
  ShowPayInAppButton: {
    name: "pay_in_ahapay_app_shown",
  },
  PressPayInAppButton: {
    name: "pay_in_ahapay_app_button_press",
  },
} as const satisfies Record<string, AnalyticsEvent>;
